import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    question: '¿Es difícil de aprender?',
    answer: 'No, se basa en impulsos biológicos que ya ves todos los días, solo que ahora sabrás qué significan.'
  }, {
    question: '¿Funciona en videollamadas?',
    answer: 'Sí, enfocándote en las microexpresiones faciales y la tensión de los hombros.'
  }, {
    question: '¿Se darán cuenta de que los estoy analizando?',
    answer: 'No, si sigues las técnicas de mirada social que explico en el manual.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-background relative overflow-hidden" data-id="element-52">
      <div className="container mx-auto px-4 max-w-3xl relative z-10" data-id="element-53">
        <div className="text-center mb-16" data-id="element-54">
          <FadeIn data-id="element-55">
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4" data-id="element-56">
              Preguntas frecuentes
            </h2>
          </FadeIn>
        </div>

        <div className="space-y-4" data-id="element-57">
          {faqs.map((faq, index) => <FadeIn key={index} delay={0.1 + index * 0.1} direction="up" data-id="element-58">
              <div className={`border rounded-2xl overflow-hidden transition-colors duration-300 ${openIndex === index ? 'border-accent/50 bg-surfaceHighlight' : 'border-white/10 bg-surface hover:border-white/20'}`} data-id="element-59">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-60">
                  <span className="text-lg sm:text-xl font-semibold text-white pr-8" data-id="element-61">
                    {faq.question}
                  </span>
                  <ChevronDown className={`w-6 h-6 text-accent shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-62" />
                </button>

                <AnimatePresence data-id="element-63">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-64">
                      <div className="p-6 pt-0 text-lg text-slate-300 leading-relaxed border-t border-white/5 mt-2" data-id="element-65">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}